import type { ReactNode } from 'react';
import { ToastProvider } from './Toast';

/**
 * Provider stack every redesign route needs ABOVE its screen component.
 * Lives at the route gate (App.tsx), not inside Shell: a screen can only
 * consume contexts from ancestors, and its own Shell is a child — so a
 * screen-level `useToast()` only works when the provider wraps the screen
 * from outside. Port PRs: wrap each redesign screen element in this.
 */
export function RedesignProviders({ children }: { children: ReactNode }) {
  return <ToastProvider>{children}</ToastProvider>;
}
